import { types } from '../../types';

const setGetUsersAction = (payload) => {
  return {
    type: types.users.SET_USERS_LIST,
    payload,
  }
}

const setGetUserAction = (payload) => {
  return {
    type: types.users.SET_USER_BY_ID,
    payload,
  }
}

const setGetWithdrawalsUserAction = (payload) => {
  return {
    type: types.users.SET_WITHDRAWALS_USER,
    payload,
  }
}

const setGetReplenishmentUserAction = (payload) => {
  return {
    type: types.users.SET_REPLENISHMENT_USER,
    payload
  }
}

const setGetHistoryGamesUserAction = (payload) => {
  return {
    type: types.users.SET_HISTORY_GAMES_USER,
    payload
  }
}

const setGetHistoryBonusGetByIdAction = (payload) => {
  return {
    type: types.users.SET_BONUSES_HISTORY,
    payload
  }
}

const setGetLastOperationAction = (payload) => {
  return {
    type: types.users.SET_LAST_OPERATION,
    payload
  }
}

const setGetRezymeAction = (payload) => {
  return {
    type: types.users.SET_REZYME,
    payload
  }
}

const setGetVerificationAction = (payload) => {
  return {
    type: types.users.SET_VERIFICATION,
    payload
  }
}

const setGetJackpotHistoryListAction = (payload) => {
  return {
    type: types.users.SET_HISTORY_LIST,
    payload,
  }
}

const setGetFreespinOperationAction = (payload) => {
  return {
    type: types.users.SET_FREESPIN_OPERATION,
    payload
  }
}

const setGetUserLoggerAction = (payload) => {
  return {
    type: types.users.SET_USER_LOGGER,
    payload
  }
}

const setGetGamesListFsAction = (payload) => {
  return {
    type: types.users.SET_GAMES_LIST,
    payload
  }
}

export {
  setGetUsersAction as SetGetUsersAction,
  setGetUserAction as SetGetUserAction,
  setGetWithdrawalsUserAction as SetGetWithdrawalsUserAction,
  setGetReplenishmentUserAction as SetGetReplenishmentUserAction,
  setGetHistoryGamesUserAction as SetGetHistoryGamesUserAction,
  setGetHistoryBonusGetByIdAction as SetGetHistoryBonusGetByIdAction,
  setGetLastOperationAction as SetGetLastOperationAction,
  setGetRezymeAction as SetGetRezymeAction,
  setGetVerificationAction as SetGetVerificationAction,
  setGetJackpotHistoryListAction as SetGetJackpotHistoryListAction,
  setGetFreespinOperationAction as SetGetFreespinOperationAction,
  setGetUserLoggerAction as SetGetUserLoggerAction,
  setGetGamesListFsAction as SetGetGamesListFsAction
}